"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const DataProvider_1 = tslib_1.__importDefault(require("../DataProvider"));
const Configuration_1 = tslib_1.__importDefault(require("../Configuration"));
var InputUserPublicDataSearchSort;
(function (InputUserPublicDataSearchSort) {
    InputUserPublicDataSearchSort["ID"] = "ID";
    InputUserPublicDataSearchSort["SCREEN_NAME"] = "SCREEN_NAME";
    InputUserPublicDataSearchSort["LAST_LOGIN_TIME"] = "LAST_LOGIN_TIME";
})(InputUserPublicDataSearchSort || (InputUserPublicDataSearchSort = {}));
class UserPublicDataProvider extends DataProvider_1.default {
    get fragments() {
        return {
            UserPublicData: () => `
        ... on UserPublicData {
          id
          role
          screenName
          username
          lastLoginTime
          avatar {
            ${this.getFragment("File")}
          }
          onlineStatus {
            ${this.getFragment("OnlineStatus")}            
          }
          ${Configuration_1.default.featureLiveChat
                ? `
          publicLivechatUser {
            ${this.getFragment("LiveChatUser", [
                    "id",
                    "chatId",
                    "userId",
                    "broadcasting",
                    "broadcastingTime",
                    "joinTime",
                    "lastOnline",
                ])}
          }
          `
                : ``}
          disabled
          verified
          background {
            ${this.getFragment("File")}
          }
          partner
        }
      `,
        };
    }
    search({ data }, fields) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return yield this.query("usersPublicDataSearch", { data }, this.getPageableFragment("UserPublicData", fields));
        });
    }
    relevantSearchByName({ name, topRole }, fields) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return yield this.query("usersRelevantSearch", { name, topRole }, this.getFragment("UserPublicData", fields));
        });
    }
}
exports.UserPublicDataProvider = UserPublicDataProvider;
//# sourceMappingURL=UserPublicDataProvider.js.map